import { render } from "./AlarmManagement.vue?vue&type=template&id=266a2c6e&scoped=true"
import script from "./AlarmManagement.vue?vue&type=script&lang=js"
export * from "./AlarmManagement.vue?vue&type=script&lang=js"

import "./AlarmManagement.vue?vue&type=style&index=0&id=266a2c6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266a2c6e"]])

export default __exports__